var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(!_vm.ready),expression:"!ready",modifiers:{"fullscreen":true}}],attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.getCacheLayout}},[(_vm.ready)?[_c(_vm.layout,{tag:"component"})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }